import React from 'react';
import { 
  Save 
} from '@mui/icons-material';
import { Button } from '@mui/material';

import FabButton from "@components/input/buttons/FabButton";

interface Props {
  disabled?: boolean;
  width?: number;
  label?: string;
  onClick: () => void;
}

export default function SaveButton({ 
  disabled = false,
  width,
  label = "",
  onClick 
}: Props) {

  if (label === "") {
    return (
      <FabButton
        disabled={disabled} 
        onClick={onClick}>
        <Save />
      </FabButton>
    );
  } else {
    return (
      <Button 
        disabled={disabled} 
        onClick={onClick} 
        style={width ? { width } : {}}
        variant="contained" color="primary">
        <Save />&nbsp;{ label }
      </Button>
    );
  }
}
